import React, { useState } from 'react';
import { PhotoProps } from './types';
import { Image, Wrapper } from './photo.styles';
import { SIZES_MAP, TEXT_SIZES_MAP } from './constants';
import { AvatarInitials } from '@shared/ui/avatar-initials/avatar-initials';

export const Photo: React.FC<PhotoProps> = ({ photoUrl, size = 'm', imageProps, name, className }) => {
    const [isShowImage, setIsShowImage] = useState(Boolean(photoUrl));
    const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        setIsShowImage(false);
        if (imageProps?.onError) {
            imageProps.onError(e);
        }
    };

    return (
        <Wrapper className={className} size={SIZES_MAP[size]}>
            {isShowImage ? (
                <Image src={photoUrl || ''} {...imageProps} onError={handleError} />
            ) : (
                <AvatarInitials name={name} size={TEXT_SIZES_MAP[size]} isOnlyName={size === 's' || size === 'xs'} />
            )}
        </Wrapper>
    );
};
